<template>
    <tbody>
        <tr v-for="item in list" v-bind:key="item.key">
            <td colspan="2">{{ item.date }}</td>
            <td>{{ item.mug11total }}</td>
            <td class="out">{{ item.mug11remain }}</td>
            <td>{{ item.mug15total }}</td>
            <td class="out">{{ item.mug15remain }}</td>
            <td>{{ item.steelmugtotal }}</td>
            <td class="out">{{ item.steelmugremain }}</td>
            <td>{{ item.specialmugtotal }}</td>
            <td class="out">{{ item.specialmugremain }}</td>
            <td>{{ item.steelbottletotal }}</td>
            <td class="out">{{ item.steelbottleremain }}</td>
            <td>{{ item.alltotal }}</td>
            <td class="out">{{ item.totalremain }}</td>
        </tr>
    </tbody>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
    name: "DataTable",
    data() {
        return {
            list: []
        }
    },
	methods: {
		async updateSelCompany() {
			let result = await axios.get('https://new.colorwayrb.com/backend/summary.php?sessionid=' + (this.$store.getters.sessionid) + '&customer=' + this.selCompany )
			
			
			var allItems = result.data

			if (allItems == null) {
				this.list = [];
			}

			//Finds all Drinkware
			var drinkware = allItems.filter(function (el) {
				return el.isDrinkware == true;
			})

			//Data into date arrays
			var ids = drinkware.map(e => e.date).filter((x, i, a) => a.indexOf(x) == i);
			var drinkwareDates = {};

			ids.forEach(i => {
				drinkwareDates[i] = drinkware.filter(e => {
					return e.date === i;
				});
			});

			//Finds key for dates e.g keys[1]
			var keys = Object.keys(drinkwareDates);
			console.log(drinkware)

			var smallMugs = [];
			for (var i = 0; i < keys.length; i++) {

				//Filter 11oz Mugs
				var mugs11Oz = drinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'Mug 11oz'
						|| el.sku == 'N0601015'
						|| el.sku == 'N0601027-BK-UK'
						|| el.sku == 'N0601027-BL-UK'
						|| el.sku == 'N0601027-PK-UK'
						|| el.sku == 'N0601027-RD-UK'
						|| el.sku == 'N0601027-BK'
						|| el.sku == 'N0601027-BL'
						|| el.sku == 'N0601027-PK'
						|| el.sku == 'N0601027-RD'
						|| el.sku == 'N0601027-GN'
						|| el.sku == 'N0601027-YL'
						;
				})

				//Filter 15oz Mugs
				var mugs15Oz = drinkwareDates[keys[i]].filter(function (el) {
					return (el.sku == 'GN0601017-2574B' || el.sku == 'N0601017');
				})

				//Filter Steel Mugs
				var steelMug = drinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'steel mug';
				})

				//Filter Special Mugs
				var specialMug = drinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'steel bottle';
				})

				//Filter Steel Bottle
				var steelBottle = drinkwareDates[keys[i]].filter(function (el) {
					return el.sku == 'special mug';
				})

				//Gets reaming and total sums 11oz Mugs
				var mugs11OzRemainAmount = 0;
				var mugs11OzTotalAmount = 0;
				mugs11Oz.forEach(function (el) {
					mugs11OzRemainAmount = mugs11OzRemainAmount + el.qty.remain
					mugs11OzTotalAmount = mugs11OzTotalAmount + parseInt(el.qty.total);

					return mugs11OzRemainAmount, mugs11OzTotalAmount
				})

				//Gets reaming and total sums 11oz Mugs
				var mugs15OzRemainAmount = 0;
				var mugs15OzTotalAmount = 0;
				mugs15Oz.forEach(function (el) {
					mugs15OzRemainAmount = mugs15OzRemainAmount + el.qty.remain
					mugs15OzTotalAmount = mugs15OzTotalAmount + parseInt(el.qty.total);

					return mugs15OzRemainAmount, mugs15OzTotalAmount
				})

				//Gets reaming and total sums Steel Mugs
				var steelMugRemainAmount = 0;
				var steelMugTotalAmount = 0;
				steelMug.forEach(function (el) {
					steelMugRemainAmount = steelMugRemainAmount + el.qty.remain
					steelMugTotalAmount = steelMugTotalAmount + parseInt(el.qty.total);

					return steelMugRemainAmount, steelMugTotalAmount
				})

				//Gets reaming and total sums Steel Mugs
				var specialMugRemainAmount = 0;
				var specialMugTotalAmount = 0;
				specialMug.forEach(function (el) {
					specialMugRemainAmount = specialMugRemainAmount + el.qty.remain
					specialMugTotalAmount = specialMugTotalAmount + parseInt(el.qty.total);

					return specialMugRemainAmount, specialMugTotalAmount
				})

				//Gets reaming and total sums Steel Bottle
				var steelBottleRemainAmount = 0;
				var steelBottleTotalAmount = 0;
				steelBottle.forEach(function (el) {
					steelBottleRemainAmount = steelBottleRemainAmount + el.qty.remain
					steelBottleTotalAmount = steelBottleTotalAmount + parseInt(el.qty.total);

					return steelBottleRemainAmount, steelBottleTotalAmount
				})

				var totalRemain = mugs11OzRemainAmount + mugs15OzRemainAmount + steelMugRemainAmount + specialMugRemainAmount + steelBottleRemainAmount
				var allTotal = mugs11OzTotalAmount + mugs15OzTotalAmount + steelMugTotalAmount + specialMugTotalAmount + steelBottleTotalAmount


				var dates = drinkwareDates[keys[i]][0].date

				var samllItems = {
					'date': dates,
					'mug11remain': mugs11OzRemainAmount,
					'mug11total': mugs11OzTotalAmount,
					'mug15remain': mugs15OzRemainAmount,
					'mug15total': mugs15OzTotalAmount,
					'steelmugremain': steelMugRemainAmount,
					'steelmugtotal': steelMugTotalAmount,
					'specialmugremain': specialMugRemainAmount,
					'specialmugtotal': specialMugTotalAmount,
					'steelbottleremain': steelBottleRemainAmount,
					'steelbottletotal': steelBottleTotalAmount,
					'totalremain': totalRemain,
					'alltotal': allTotal


				}
				smallMugs.push(samllItems)
				console.log(drinkwareDates[keys[i]])
			}
			this.list = smallMugs
			//console.log(names)
			console.log(smallMugs)
		}
	}, 
    async mounted() {
        let result = await axios.get('https://new.colorwayrb.com/backend/summary.php?sessionid=' + (this.$store.getters.sessionid))
        var allItems = result.data

        //Finds all Drinkware
        var drinkware = allItems.filter(function (el) {
            return el.isDrinkware == true;
        })

        //Data into date arrays
        var ids = drinkware.map(e => e.date).filter((x, i, a) => a.indexOf(x) == i);
        var drinkwareDates = {};

        ids.forEach(i => {
            drinkwareDates[i] = drinkware.filter(e => {
                return e.date === i;
            });
        });

        //Finds key for dates e.g keys[1]
        var keys = Object.keys(drinkwareDates);
        console.log(drinkware)

        var smallMugs = [];
        for (var i = 0; i < keys.length; i++) {

            //Filter 11oz Mugs
            var mugs11Oz = drinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'Mug 11oz'
                    || el.sku == 'N0601015'
                    || el.sku == 'N0601027-BK-UK'
                    || el.sku == 'N0601027-BL-UK'
                    || el.sku == 'N0601027-PK-UK'
                    || el.sku == 'N0601027-RD-UK'
                    || el.sku == 'N0601027-BK'
                    || el.sku == 'N0601027-BL'
                    || el.sku == 'N0601027-PK'
                    || el.sku == 'N0601027-RD'
                    || el.sku == 'N0601027-GN'
                    || el.sku == 'N0601027-YL'
                    ;
            })

            //Filter 15oz Mugs
            var mugs15Oz = drinkwareDates[keys[i]].filter(function (el) {
                return (el.sku == 'GN0601017-2574B'  || el.sku == 'N0601017');
            })

            //Filter Steel Mugs
            var steelMug = drinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'steel mug';
            })

            //Filter Special Mugs
            var specialMug = drinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'steel bottle';
            })

            //Filter Steel Bottle
            var steelBottle = drinkwareDates[keys[i]].filter(function (el) {
                return el.sku == 'special mug';
            })

            //Gets reaming and total sums 11oz Mugs
            var mugs11OzRemainAmount = 0;
            var mugs11OzTotalAmount = 0;
            mugs11Oz.forEach(function (el) {
                mugs11OzRemainAmount = mugs11OzRemainAmount + el.qty.remain
                mugs11OzTotalAmount = mugs11OzTotalAmount + parseInt(el.qty.total);

                return mugs11OzRemainAmount, mugs11OzTotalAmount
            })

            //Gets reaming and total sums 11oz Mugs
            var mugs15OzRemainAmount = 0;
            var mugs15OzTotalAmount = 0;
            mugs15Oz.forEach(function (el) {
                mugs15OzRemainAmount = mugs15OzRemainAmount + el.qty.remain
                mugs15OzTotalAmount = mugs15OzTotalAmount + parseInt(el.qty.total);

                return mugs15OzRemainAmount, mugs15OzTotalAmount
            })

            //Gets reaming and total sums Steel Mugs
            var steelMugRemainAmount = 0;
            var steelMugTotalAmount = 0;
            steelMug.forEach(function (el) {
                steelMugRemainAmount = steelMugRemainAmount + el.qty.remain
                steelMugTotalAmount = steelMugTotalAmount + parseInt(el.qty.total);

                return steelMugRemainAmount, steelMugTotalAmount
            })

            //Gets reaming and total sums Steel Mugs
            var specialMugRemainAmount = 0;
            var specialMugTotalAmount = 0;
            specialMug.forEach(function (el) {
                specialMugRemainAmount = specialMugRemainAmount + el.qty.remain
                specialMugTotalAmount = specialMugTotalAmount + parseInt(el.qty.total);

                return specialMugRemainAmount, specialMugTotalAmount
            })

            //Gets reaming and total sums Steel Bottle
            var steelBottleRemainAmount = 0;
            var steelBottleTotalAmount = 0;
            steelBottle.forEach(function (el) {
                steelBottleRemainAmount = steelBottleRemainAmount + el.qty.remain
                steelBottleTotalAmount = steelBottleTotalAmount + parseInt(el.qty.total);

                return steelBottleRemainAmount, steelBottleTotalAmount
            })

            var totalRemain = mugs11OzRemainAmount + mugs15OzRemainAmount + steelMugRemainAmount + specialMugRemainAmount + steelBottleRemainAmount
            var allTotal = mugs11OzTotalAmount + mugs15OzTotalAmount + steelMugTotalAmount + specialMugTotalAmount + steelBottleTotalAmount


            var dates = drinkwareDates[keys[i]][0].date

            var samllItems = {
                'date': dates,
                'mug11remain': mugs11OzRemainAmount,
                'mug11total': mugs11OzTotalAmount,
                'mug15remain': mugs15OzRemainAmount,
                'mug15total': mugs15OzTotalAmount,
                'steelmugremain': steelMugRemainAmount,
                'steelmugtotal': steelMugTotalAmount,
                'specialmugremain': specialMugRemainAmount,
                'specialmugtotal': specialMugTotalAmount,
                'steelbottleremain': steelBottleRemainAmount,
                'steelbottletotal': steelBottleTotalAmount,
                'totalremain': totalRemain,
                'alltotal': allTotal


            }
            smallMugs.push(samllItems)
            console.log(drinkwareDates[keys[i]])
        }
        this.list = smallMugs
        //console.log(names)
        console.log(smallMugs)
    },
	computed: {
		selCompany () {
			return this.$store.getters.getSummaryCompany
		}
	},
	watch: {
		selCompany(newVal, oldVal) {
			console.log('Changed...' + newVal);
			this.updateSelCompany();
		}
	}
	
});
</script>

<style lang="css" scoped>
</style>